import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SvedIOUInfoType} from "../../../../models/dossier";
import {DossierService} from "../../../../services";
import {IDossierSubService} from "../IDossierSub.service";
import {DossierBasePageComponent} from "../dossierBasePage.component";
import {SvedIOUDossierService} from "./svedIOUDossier.service";
import {
  AlertPanelService,
  ITable,
  ITableCallBack,
  ITableItemDescriptor,
  TableCompComponent
} from "@amlCore/components";
import {IouInfoDossierComponent} from "../components/iouInfo";
import {DictionaryService, UserService} from "@amlCore/services";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileSaverService} from "ngx-filesaver";
import moment from "moment/moment";


@Component({
  selector: 'app-sved-iou-dossier',
  styleUrls: ['../dossier.css'],
  templateUrl: './svedIOUDossier.component.html'
})
export class SvedIOUDossierComponent extends DossierBasePageComponent implements OnInit, ITable {

  modelPage: Array<SvedIOUInfoType>;
  itemDescriptor: ITableItemDescriptor;
  isTableTab = true;
  @ViewChild('tableComp', {static: true}) tableComp: TableCompComponent;

  constructor(protected dossierService: DossierService,
              protected route: ActivatedRoute,
              private svedIOUDossierService: SvedIOUDossierService,
              protected dictSrv: DictionaryService,
              protected router: Router,
              protected userService: UserService,
              protected alertPanelSrv: AlertPanelService,
              protected modalService: NgbModal,
              protected fSaver: FileSaverService) {
    super(dossierService, route, dictSrv, router, userService, alertPanelSrv, modalService, fSaver);
  }

  ngOnInit(): void {
    // Инициализация вкладки
    this.modelPage = this.initPage();
    // Описание элемента таблицы
    this.itemDescriptor = {
      create: this.svedIOUDossierService.getSvedIUO.bind(this.svedIOUDossierService, this.modelPage),
      component: IouInfoDossierComponent,
      params: {
        typePage: this.typePage
      }
    } as ITableItemDescriptor;
  }

  getService(): IDossierSubService {
    return this.svedIOUDossierService;
  }

  callbackItemClosed(event: ITableCallBack) {
    this.saveTableItem(event);
  }

  getTypeDesc(item: SvedIOUInfoType): string {
    return [item?.organUpr, item?.type, item?.vidKolOU].filter(v => v && v.code != '99')
      .map(v => v.name).join(", ");
  }

  isActiveItem(item: SvedIOUInfoType): boolean {
    return !item.dateEndV || moment().isSameOrBefore(moment(item.dateEndV,"DD.MM.YYYY"), 'day');
  }

  destroy(): void {
    // ТУТ писать реализацию ngOnDestroy для компонента
  }

}
